
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[site]/[...pageId]",
      function () {
        return require("private-next-pages/_sites/[site]/[...pageId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[site]/[...pageId]"])
      });
    }
  